<template>

    <div>
        <div class="comment-wrap" v-if="place_info.place.links && place_info.place.links.length && rate_id == 3">
            <button @click="openSocialModal" class="write-review-button primaryButton block">
                <template v-for="(link, index) in place_info.place.links">
                    <img alt="" src="@/assets/icons/ic_facebook_color.svg" v-if="link.network.id == 1">
                    <img alt="" src="@/assets/icons/ic_yelp.svg" v-if="link.network.id == 2">
                    <img alt="" src="@/assets/icons/ic_google.svg" v-if="link.network.id == 3">
                    <img alt="" src="@/assets/icons/ic_tripadvisor_color.svg" v-if="link.network.id == 4">
                    <img alt="" src="@/assets/icons/ic_vk_color.svg" v-if="link.network.id == 6">
                    <img alt="" src="@/assets/icons/ic_instagram_color.svg" v-if="link.network.id == 5">
                    <img alt="" src="@/assets/icons/ic_web_color.svg" v-if="link.network.id == 7">
                    <img alt="" src="@/assets/icons/ic_donate.svg" v-if="link.network.alias == 'donate'">
                    <img alt="" src="@/assets/icons/ic_adopt.png" v-if="link.network.alias == 'adopt'" style="width: 22px; height: 22px;">
                    <img alt="" src="@/assets/icons/ic_trustpilot.svg" v-if="link.network.alias == 'trustpilot'">
                    <img alt="" src="@/assets/icons/ic_capterra.svg" v-if="link.network.alias == 'capterra'">
                </template>
                <span class="write-review-button__text">{{ translate('writeAReview') }}</span>
            </button>
        </div>
        <!-- social review modal -->
        <div content-class="custom-modal social-modal" v-if="socialModal">
            <div class="popupModal" :class="{active: socialModal}">
                <div class="popupModal__wrapper" @mousedown = 'underlayClick'>
                    <div class="popupModal__content" id="popupModal__content">
                        <div class="close-icon__wrapper">
                            <span @click="cancelSocialModal" class="close-icon"></span>
                        </div>

                        <div class="note-icon-wrap">
                            <img alt="" src="@/assets/re/socialReviewIcon.svg">
                        </div>

                        <h2 class="note-title">{{ translate('writeAReview') }}</h2>
                        <h4 class="note-description">{{ translate('writeAReviewTitle', [place_info.place.name]) }}</h4>

                        <button :class="link.network.alias + '-button'"
                                  :key="index"
                                  @click="openSocialLink(link)"
                                  class="primaryButton"
                                  v-for="(link, index) in place_info.place.links"
                        >
                            <img alt="" src="@/assets/icons/fb-light.svg" v-if="link.network.id == 1">
                            <img alt="" src="@/assets/icons/yelp-light.svg" v-if="link.network.id == 2">
                            <img alt="" src="@/assets/icons/google-light.svg" v-if="link.network.id == 3">
                            <img alt="" src="@/assets/icons/tripadvisor-light.svg" v-if="link.network.id == 4">
                            <img alt="" src="@/assets/icons/ic_vk_light.svg" v-if="link.network.id == 6">
                            <img alt="" src="@/assets/icons/ic_instagram_light.svg" v-if="link.network.id == 5">
                            <img alt="" src="@/assets/icons/ic_web_light.svg" v-if="link.network.id == 7">
                            <img alt="" src="@/assets/icons/ic_donate_light.svg" v-if="link.network.alias == 'donate'">
                            <img alt="" src="@/assets/icons/ic_adopt_light.png" v-if="link.network.alias == 'adopt'" style="width: 22px; height: 22px;">
                            <img alt="" src="@/assets/icons/ic_trustpilot.svg" v-if="link.network.alias == 'trustpilot'">
                            <img alt="" src="@/assets/icons/ic_capterra.svg" v-if="link.network.alias == 'capterra'">
                            {{link.network.name}}
                        </button>

                        <template>
                            <button @click="cancelSocialModal" class="socialCancel-btn" variant="default">
                                {{ translate('Cancel') }}
                            </button>
                        </template>
                    </div>
                </div>
            </div>

        </div>

    </div>

</template>

<script>
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import logAnalyticsEvent from '@/helpers/analytics'
    import rateMixin from '@/mixins/rateMixin';

    export default {
        name: 'socialReviewBtnFlow',
        mixins: [mixin, rateMixin],

        data() {
            return {
                langShow: false,
                langSelect: this.$ml.current,
                socialModal: false,
            }
        },

        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {}
                }
            },
            state: Boolean
        },
        watch: {
            state(value) {
                this.socialModal = value
            },
        },

        mounted() {

        },

        computed: {
            ...mapState({
                userInfo: state => state.auth.userInfo,
                accessToken: state => state.auth.accessToken,
            }),
            ...mapGetters({
                giveaway: 'rate/getGiveaway',
                place_info: 'rate/getPlaceInfo',
                rate_id: 'rate/getRateValue',
                rateUid: 'rate/getRateUid',
            }),
        },
        methods: {
            ...mapActions({
                logoutRemote: 'auth/logout',
            }),
            ...mapMutations({
                removeKeys: 'auth/removeKeys',
            }),

            openSocialModal() {
                logAnalyticsEvent('soc_review_btn_click')
                this.socialModal = true
            },

            cancelSocialModal() {
                logAnalyticsEvent('soc_review_dialog_cancel')
                this.socialModal = false
            },

            openSocialLink(link) {
                logAnalyticsEvent('soc_review_item_click')
                this.sendSocialClickToServer(this.rateUid, link.uid)
                window.open(link.url, '_blank');
            },
            underlayClick (e) {
                if(this.isClickOutOfBlock('popupModal__content', e.target)) {
                    this.socialModal = false
                }
            }

        },

    }
</script>

<style scoped>
    .comment-wrap {
        margin-top: 0px;
        width: 100%;
        max-width: 380px;
    }
    button.primaryButton, button.primaryButton span {
        margin-bottom: 10px;
    }
    button.primaryButton.facebook-button{
        background-color: #448aff;
        border: #448aff;
    }
    button.primaryButton.yelp-button {
        background-color: #FE5022;
        border: #FE5022;
    }
    button.primaryButton.google-button{
        background-color: #5D8FF1;
        border: #5D8FF1
    }
    button.primaryButton.instagram-button {
        background-color: #E1306C;
        border: #E1306C;
    }
    button.primaryButton.website-button {
        background-color: #ffb12b;
        border: #ffb12b;
    }
    .socialCancel-btn {
        border: none;
        background-color: white;
        margin-bottom: 15px;
        font-size: 16px;
        padding-top: 12px;
        padding-bottom: 12px;
        cursor: pointer;
    }

    .comment-wrap button {
        margin-top: 10px;
        background-color: #ffffff;
    }
    .write-review-button__text {
        color: #3F405C;
    }
    @media screen and (max-width: 768px) {

        .comment-wrap button {
            margin-top: 0;
            margin-bottom: 0;
        }

        .comment-wrap button,
        .submit button {
            font-size: 0.85em;
            min-height: 42px;
            padding: 0;
            margin-top: 10px;
            padding: 0 1em;
        }
    }

</style>
